export default __webpack_public_path__ + "static/media/time-line.edf88852.svg";